import React, { useState, useEffect } from 'react';
import '../App.css';
import Swal from 'sweetalert2'; // SweetAlert2 임포트

function ContractorFormModal({ isOpen, onClose, onSave, mode, initialData }) {
  const [contractorName, setContractorName] = useState('');
  const [contractorAddress, setContractorAddress] = useState('');
  const [contractorRepresentative, setContractorRepresentative] = useState('');
  const [remarks, setRemarks] = useState('');

  useEffect(() => {
    if (isOpen && mode === 'edit' && initialData) {
      setContractorName(initialData.name || '');
      setContractorAddress(initialData.address || '');
      setContractorRepresentative(initialData.representative || '');
      setRemarks(initialData.remarks || '');
    } else if (isOpen && mode === 'add') {
      setContractorName('');
      setContractorAddress('');
      setContractorRepresentative('');
      setRemarks('');
    }
  }, [isOpen, mode, initialData]);

  const handleSubmit = () => {
    if (!contractorName.trim() || !contractorAddress.trim() || !contractorRepresentative.trim()) {
      Swal.fire({
        icon: 'warning',
        title: '입력 오류',
        text: '모든 필드를 입력해주세요.',
      });
      return;
    }

    onSave({
      id: initialData ? initialData.id : null,
      name: contractorName,
      address: contractorAddress,
      representative: contractorRepresentative,
      remarks: remarks,
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-button">×</button>
        <h1>{mode === 'add' ? '새 시공사 등록' : '시공사 정보 수정'}</h1>
        <hr/><br/>
        <div className="form-group">
          <label>시공사명</label>
          <input
            type="text"
            value={contractorName}
            onChange={(e) => setContractorName(e.target.value)}
            placeholder="시공사명을 입력하세요"
          />
        </div>
        <div className="form-group">
          <label>시공사 주소</label>
          <input
            type="text"
            value={contractorAddress}
            onChange={(e) => setContractorAddress(e.target.value)}
            placeholder="시공사 주소를 입력하세요"
          />
        </div>
        <div className="form-group">
          <label>대표</label>
          <input
            type="text"
            value={contractorRepresentative}
            onChange={(e) => setContractorRepresentative(e.target.value)}
            placeholder="대표 이름을 입력하세요"
          />
        </div>
        <div className="form-group">
          <label>비고</label>
          <textarea
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="비고를 입력하세요"
            rows="4"
            style={{ width: '100%', minHeight: '100px', border: '1px solid #ccc', borderRadius: '4px', padding: '8px' }}
          />
        </div>
        <div className="form-actions">
          <button onClick={handleSubmit} className="submit-button">{mode === 'add' ? '등록' : '수정'}</button>
        </div>
      </div>
    </div>
  );
}

export default ContractorFormModal;
